import dynamic from "next/dynamic";
import React   from "react";

import Toast                     from "_common/toast";
import { setMonetisationStatus } from "_services/api/creator-dashboard";

const Presentation       = dynamic ( () => import ( "./presentation" ) );
const PresentationMobile = dynamic ( () => import ( "./presentationMobile" ) );

const component = props => {
	const {
		type,
		setMonetisationData = () => {},
		skipModalStatusCall = false,
		isMobile
	} = props;

	const updateModalStatus = async () => {
		try {
			const data = await setMonetisationStatus ( type );

			setMonetisationData ( data );
		} catch ( e ) {
			Toast.error ( "Unable to update modal status" );
		}
	};

	if ( isMobile )
		return (
			<PresentationMobile
				skipModalStatusCall = { skipModalStatusCall }
				updateModalStatus   = { updateModalStatus }
				{ ...props }
			/>
		);

	return (
		<Presentation
			skipModalStatusCall = { skipModalStatusCall }
			updateModalStatus   = { updateModalStatus }
			{ ...props }
		/>
	);
};

export default component;